export interface IMemberCard {
  id: number | null;
  cardNumber: string | null;
  dateIssued: Date | string | null;
  status: boolean;
  paid: boolean;
}

export class MemberCard implements IMemberCard {
  id;
  cardNumber;
  dateIssued;
  status;
  paid;

  constructor(config: IMemberCard) {
    this.id = config.id;
    this.cardNumber = config.cardNumber;
    this.dateIssued = config.dateIssued;
    this.status = config.status;
    this.paid = config.paid;
  }
}
